import React from "react";
import TriggerNodeTemplate from "../templates/TriggerNodeTemplate";
import { Tooltip, Typography, Box } from "@mui/material";

export default function SQLNode({ id, type, data }) {
  console.log(data);

  // Helper function to format conditions
  const formatConditions = () => {
    const conditions = data.conditions;

    if (!Array.isArray(conditions) || conditions.length === 0) {
      return "No conditions set";
    }

    // Group by logical operator
    const andConditions = conditions.filter((c) => c.logicalOperator === "AND");
    const orConditions = conditions.filter((c) => c.logicalOperator === "OR");

    const formatCondition = (condition) => {
      if (!condition.table || !condition.field || !condition.operator)
        return "";
      return `${condition.table}.${condition.field} ${condition.operator} ${condition.value}`;
    };

    let result = "";
    if (andConditions.length > 0) {
      result += andConditions
        .map(formatCondition)
        .filter(Boolean)
        .join(" AND ");
    }
    if (orConditions.length > 0) {
      if (result) result += " OR ";
      result += orConditions.map(formatCondition).filter(Boolean).join(" OR ");
    }

    return result || "Conditions configured";
  };

  // Format time interval
  const formatTimeInterval = () => {
    if (data.timeAmount && data.timeInterval) {
      return `Every ${data.timeAmount} ${data.timeInterval}`;
    }
    return "";
  };

  const conditionsText = formatConditions();
  const timeIntervalText = formatTimeInterval();
  const displayText = timeIntervalText
    ? `${timeIntervalText} | ${conditionsText}`
    : conditionsText;

  return (
    <TriggerNodeTemplate id={id} type={type} data={data}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        {/* Conditions and time interval */}
        <Tooltip title={displayText}>
          <Typography
            noWrap
            fontSize={8}
            sx={{
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {displayText}
          </Typography>
        </Tooltip>
      </Box>
    </TriggerNodeTemplate>
  );
}
